var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnOrganizations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18V26",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26V25C31 23.3431 29.6569 22 28 22H16C14.3431 22 13 23.3431 13 25V26",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 26,
    width: 6,
    height: 6,
    rx: 3,
    transform: "rotate(90 25 26)",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 12,
    width: 6,
    height: 6,
    rx: 3,
    transform: "rotate(90 25 12)",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 26,
    width: 6,
    height: 6,
    rx: 3,
    transform: "rotate(90 34 26)",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 6,
    height: 6,
    rx: 3,
    transform: "rotate(90 16 26)",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnOrganizations);
export default __webpack_public_path__ + "static/media/btn_organizations.4317e67485a1ad1546842a56c5599c65.svg";
export { ForwardRef as ReactComponent };